<div class="flex flex-col flex-auto min-w-0 h-full overflow-hidden">
  <div class="flex-auto h-full overflow-hidden">
    <div class="h-full max-content-h">
      <div class="drk-page-wrapper flex flex-col lg:flex-row gap-4 h-full p-4 bg-gray-50">
        
        <!-- Pannello Sinistro: Report Dettagliato -->
        <div class="flex-1 bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden flex flex-col relative min-w-0">
          <!-- Header -->
          <div class="px-5 py-3 border-b border-gray-100 flex items-center justify-between shrink-0 bg-gray-50/50 z-10">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-[var(--custom-color)]/10 rounded-lg text-[var(--custom-color)]" style="background-color: color-mix(in srgb, var(--custom-color) 15%, transparent);">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
              </div>
              <div>
                <h2 class="text-sm font-bold text-gray-700 uppercase tracking-wider">Area Report</h2>
                <p class="text-gray-400 text-xs mt-0.5">Visualizzazione query e analisi salvate</p>
              </div>
            </div>
          </div>
      <!-- Nessuna selezione -->
      <div *ngIf="!selectedAnalysisId && !isLoadingReport" class="flex-1 flex items-center justify-center">
        <div class="text-center">
          <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          <h3 class="text-lg font-medium text-gray-900">Seleziona un'analisi</h3>
          <p class="mt-1 text-gray-500 text-sm">Scegli un'analisi dal pannello di destra per visualizzarne il report.</p>
        </div>
      </div>

      <!-- Caricamento -->
      <div *ngIf="isLoadingReport" class="flex-1 flex items-center justify-center">
        <svg class="animate-spin h-8 w-8 text-[var(--custom-color)]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>

      <!-- Report caricato -->
      <div *ngIf="selectedReport && !isLoadingReport" class="flex flex-col h-full overflow-y-auto custom-scrollbar p-8">
        <div class="mb-8 border-l-4 pl-5 border-[var(--custom-color)]">
          <h3 class="text-3xl font-extrabold text-gray-900 tracking-tight leading-tight">{{ selectedReport.OriginalPrompt || 'Analisi senza titolo' }}</h3>
          <p class="text-sm text-gray-500 mt-3 flex items-center gap-2 font-medium">
            <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            Ultima modifica: {{ parseDate(selectedReport.LastEditDate || selectedReport.Timestamp || selectedReport.TimeStamp) | date:'dd/MM/yyyy HH:mm' }}
          </p>
        </div>

        <div class="flex flex-col gap-8">
          <!-- Text Content -->
          <div *ngIf="selectedReport.Content" class="prose prose-sm max-w-none text-gray-800 bg-gray-50 p-5 rounded-2xl border border-gray-200 shadow-sm" [innerHTML]="selectedReport.Content"></div>
          
          <!-- Chart Data -->
          <div *ngIf="selectedReport.ChartData" class="w-full min-h-[400px] border border-gray-200 rounded-2xl p-4 shadow-sm bg-white">
            <apx-chart class="w-full h-full block" 
              [series]="selectedReport.ChartData.series" 
              [chart]="selectedReport.ChartData.chart"
              [dataLabels]="selectedReport.ChartData.dataLabels" 
              [plotOptions]="selectedReport.ChartData.plotOptions"
              [xaxis]="selectedReport.ChartData.xaxis" 
              [yaxis]="selectedReport.ChartData.yaxis"
              [theme]="selectedReport.ChartData.theme">
            </apx-chart>
          </div>
          
          <!-- Table Data -->
          <div *ngIf="selectedReport.TableData" class="w-full bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
            <div class="bg-gray-100 px-5 py-3 border-b border-gray-200">
              <span class="text-sm font-bold text-gray-700 tracking-wider">Tabella Dati</span>
            </div>
            <div class="overflow-x-auto custom-scrollbar">
              <table class="min-w-full divide-y divide-gray-200 text-sm">
                <thead class="bg-gray-50">
                  <tr>
                    <th *ngFor="let col of selectedReport.TableData.columns" class="px-5 py-3 text-left text-xs font-semibold text-gray-600 whitespace-nowrap">
                      {{ col.name }}
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-100">
                  <tr *ngFor="let row of selectedReport.TableData.paginatedRows || selectedReport.TableData.rows" class="hover:bg-gray-50 transition-colors">
                    <td *ngFor="let cell of row" class="px-5 py-3 text-sm text-gray-800 whitespace-nowrap">
                      {{ cell }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Query SQL -->
          <div *ngIf="selectedReport.OriginalQuery" class="w-full bg-gray-800 rounded-2xl overflow-hidden shadow-sm">
             <div class="bg-gray-900 px-5 py-3 border-b border-gray-700 flex justify-between items-center">
              <span class="text-sm font-bold text-gray-300 tracking-wider">Query SQL</span>
              <span class="text-xs text-gray-500 uppercase tracking-widest font-bold">SQL</span>
            </div>
            <div class="p-5 overflow-x-auto custom-scrollbar">
              <pre class="m-0 text-xs text-gray-200"><code class="whitespace-pre-wrap">{{ selectedReport.OriginalQuery }}</code></pre>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pannello di Destra (Analisi Salvate e Condivise) -->
    <div class="flex flex-col h-full bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden font-sans w-full lg:w-[350px] shrink-0">
      <!-- Tabs Header -->
      <div class="flex border-b border-gray-200 bg-gray-50 shrink-0">
        <button class="flex-1 py-4 text-sm font-semibold transition-colors focus:outline-none border-b-2"
          [ngClass]="activeTab === 'saved' ? 'border-[var(--custom-color)] text-[var(--custom-color)] bg-white' : 'border-transparent text-gray-500 hover:text-gray-700'"
          (click)="activeTab = 'saved'">
          Le tue Analisi
        </button>
        <button class="flex-1 py-4 text-sm font-semibold transition-colors focus:outline-none border-b-2"
          [ngClass]="activeTab === 'shared' ? 'border-[var(--custom-color)] text-[var(--custom-color)] bg-white' : 'border-transparent text-gray-500 hover:text-gray-700'"
          (click)="activeTab = 'shared'">
          Condivise
        </button>
      </div>

      <!-- Tabs Content -->
      <div class="flex-1 overflow-y-auto p-4 custom-scrollbar bg-gray-50/50 space-y-3 relative">
        <div *ngIf="isLoadingList" class="absolute inset-0 bg-white/80 z-10 flex items-center justify-center">
           <svg class="animate-spin h-6 w-6 text-[var(--custom-color)]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>

        <!-- Tab: Saved -->
        <ng-container *ngIf="activeTab === 'saved'">
          <div *ngIf="savedAnalyses.length === 0 && !isLoadingList" class="text-center py-10 text-gray-400 text-sm">
            Nessuna analisi salvata.
          </div>
          <div *ngFor="let item of savedAnalyses" (click)="loadAnalysis(item)"
            class="p-4 rounded-xl border shadow-sm transition-all cursor-pointer group"
            [style.backgroundColor]="selectedAnalysisId === getAnalysisId(item) ? 'var(--custom-color)' : ''"
            [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'border-[var(--custom-color)]' : 'bg-white border-gray-100 hover:shadow-md'">
            <div class="flex items-start justify-between">
              <h4 class="text-sm font-bold line-clamp-2 leading-snug transition-colors"
                [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-gray-800 group-hover:text-[var(--custom-color)]'">
                {{ item.OriginalPrompt || 'Analisi senza titolo' }}
              </h4>
            </div>
            <div class="mt-3 flex items-center text-xs"
              [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white/80' : 'text-gray-500'">
              <span class="flex items-center font-medium">
                <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                {{ parseDate(item.LastEditDate) | date:'dd/MM/yy HH:mm' }}
              </span>
            </div>
          </div>
        </ng-container>

        <!-- Tab: Shared -->
        <ng-container *ngIf="activeTab === 'shared'">
          <div *ngIf="sharedAnalyses.length === 0 && !isLoadingList" class="text-center py-10 text-gray-400 text-sm">
            Nessuna analisi condivisa.
          </div>
          <div *ngFor="let item of sharedAnalyses" (click)="loadAnalysis(item)"
            class="p-4 rounded-xl border shadow-sm transition-all cursor-pointer group"
            [style.backgroundColor]="selectedAnalysisId === getAnalysisId(item) ? 'var(--custom-color)' : ''"
            [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'border-[var(--custom-color)]' : 'bg-white border-gray-100 hover:shadow-md'">
            <div class="flex items-start justify-between">
              <h4 class="text-sm font-bold line-clamp-2 leading-snug transition-colors"
                [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-gray-800 group-hover:text-[var(--custom-color)]'">
                {{ item.AnalysisId.text || 'Sconosciuto' }}
              </h4>
            </div>
            <div class="mt-3 flex flex-col gap-2 text-xs"
              [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white/80' : 'text-gray-500'">
              
              <span *ngIf="item.SentTo && item.SentTo.length > 0" class="flex items-center font-bold" 
                [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-[var(--custom-color)]'">
                <svg class="w-4 h-4 mr-1.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                <span class="truncate" [title]="item.SentTo.join(', ')">Inviato a: {{ item.SentTo.join(', ') }}</span>
              </span>
              
              <span *ngIf="item.ReceivedFrom && item.ReceivedFrom.length > 0" class="flex items-center font-bold" 
                [ngClass]="selectedAnalysisId === getAnalysisId(item) ? 'text-white' : 'text-green-600'">
                <svg class="w-4 h-4 mr-1.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"></path></svg>
                <span class="truncate">Ricevuto da: {{ item.ReceivedFrom.join(', ') }}</span>
              </span>
              
              <span class="flex items-center font-medium mt-1">
                <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                {{ parseDate(item.LastEditDate) | date:'dd/MM/yy HH:mm' }}
              </span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    </div>
  </div>
</div>
